import { createContext } from 'react';
import type { ChangeEvent } from 'react';

export type ContextValue = {
    name: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    value: readonly string[];
    error?: boolean;
};

export const Context = createContext<ContextValue>({
    name: '',
    value: [],
});

export const { Consumer } = Context;
export const { Provider } = Context;
